//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    maxTextLength: Number,
    cutoffLength: Number,
    expandText: String,
    collapseText: String
  },
  data: function data() {
    return {
      isExpanded: false,
      shortText: ''
    };
  },
  computed: {
    hasLinkLabels: function hasLinkLabels() {
      return !!this.collapseText && !!this.expandText;
    },
    isExpandable: function isExpandable() {
      return this.hasLinkLabels && !!this.shortText && this.shortText.length > 0;
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var fullTextRef = this.$refs.fullText;

      if (this.hasLinkLabels && this.maxTextLength > 0 && fullTextRef && fullTextRef.textContent) {
        var fullTextContent = fullTextRef.textContent.trim();

        if (fullTextContent.length > this.maxTextLength) {
          var cutoff = this.cutoffLength || this.maxTextLength;
          this.shortText = fullTextContent.substr(0, cutoff) + '...';
        }
      }
    },
    toggle: function toggle(event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
      var eventName = this.isExpanded ? 'expand' : 'collapse';
      this.$emit(eventName);
    }
  }
};